import { t } from 'i18next';

import { RestrictionTypes } from 'partsOld/enums';

export const restrictionTypesOptions = () => [
  { value: RestrictionTypes.ALL, label: t('labelAllParts') },
  {
    value: RestrictionTypes.INVENTORY_ANY_LOCATION,
    label: t('labelCurrentInventory'),
  },
  {
    value: RestrictionTypes.INVENTORY_MY_LOCATION,
    label: t('labelInventoryMyLocation'),
  },
  { value: RestrictionTypes.UOM_MISMATCH, label: t('labelUomMismatch') },
];
